import { createRequest } from "helpers/tools";

export const getYandexMetricaAuthUrl = async () => {
    return await createRequest({
        suffix: `destinations/yandex-metrica/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const postAuthorizeYandexMetrica = async (payload) => {
    return await createRequest({
        suffix: `destinations/yandex-metrica/authorize`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const postSaveYandexMetrica = async (payload) => {
    return await createRequest({
        suffix: `destinations/yandex-metrica/save`,
        handleError: true,
        method: "post",
        payload,
    });
};
